class DrvIngredients extends HTMLElement {
  connectedCallback() {
    this.cards = [...this.querySelectorAll('.drv-ingredient')];
    if (!this.cards.length) return;
    this.row = this.querySelector('.drv-ingredients__row');
    this.thumbRow = document.createElement('div');
    this.thumbRow.className = 'drv-ingredients__thumbrow';
    this.row.appendChild(this.thumbRow);
    window.addEventListener('resize', () => this.place());
    const barsWrap = this.querySelector('.drv-ingredients__bars');
    this.bars = this.cards.map((card, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'drv-ingredients__bar';
      if (this.dataset.barLabel) b.setAttribute('aria-label', this.dataset.barLabel.replace('[index]', i + 1));
      b.addEventListener('click', () => this.set(i));
      barsWrap.appendChild(b);
      return b;
    });
    this.cards.forEach((card, i) => {
      card.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 990px)').matches) this.set(i);
      });
      card.addEventListener('click', () => this.set(i));
    });
    let downX = null;
    let moved = false;
    this.row.addEventListener('pointerdown', (e) => { downX = e.clientX; moved = false; });
    this.row.addEventListener('pointermove', (e) => { if (downX !== null && Math.abs(e.clientX - downX) > 10) moved = true; });
    this.row.addEventListener('click', (e) => {
      if (moved && e.target.closest('.drv-ingredient__link')) e.preventDefault();
      moved = false;
      downX = null;
    }, true);
    const n = this.cards.length;
    this.querySelector('[data-prev]').addEventListener('click', () => this.set((this.index - 1 + n) % n));
    this.querySelector('[data-next]').addEventListener('click', () => this.set((this.index + 1) % n));
    if (window.DrvDrag) {
      window.DrvDrag.swipe(this.row, () => this.set((this.index - 1 + n) % n), () => this.set((this.index + 1) % n), '.drv-ingredients__thumbrow');
      window.DrvDrag.scroll(this.thumbRow);
    }
    this.set(0);
    this.sizePanels();
    if ('ResizeObserver' in window) new ResizeObserver(() => this.sizePanels()).observe(this.row);
  }

  sizePanels() {
    const rowStyle = getComputedStyle(this.row);
    const width = this.row.clientWidth - (parseFloat(rowStyle.paddingLeft) || 0) - (parseFloat(rowStyle.paddingRight) || 0);
    const gap = parseFloat(rowStyle.columnGap) || 0;
    const n = this.cards.length;
    this.row.style.removeProperty('--drv-ingredients-closed-w');
    const basis = parseFloat(getComputedStyle(this.cards[0]).flexBasis) || 0;
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    const openMin = (parseFloat(rowStyle.getPropertyValue('--drv-ingredients-open-min')) || 0) * rem;
    const fit = n > 1 ? (width - openMin - (n - 1) * gap) / (n - 1) : basis;
    const closed = window.matchMedia('(min-width: 990px)').matches && fit < basis ? Math.max(0, fit) : basis;
    if (closed < basis) this.row.style.setProperty('--drv-ingredients-closed-w', `${closed}px`);
    const free = width - n * closed - (n - 1) * gap;
    const open = free >= 0 ? closed + free : (width - (n - 1) * gap) / n;
    this.row.style.setProperty('--drv-ingredients-open-w', `${Math.max(0, open)}px`);
  }

  set(i) {
    this.index = i;
    this.cards.forEach((c, j) => c.classList.toggle('is-active', j === i));
    this.bars.forEach((b, j) => b.classList.toggle('is-active', j === i));
    this.place();
  }

  place() {
    const mobile = !window.matchMedia('(min-width: 990px)').matches;
    const key = mobile ? 'm' + this.index : 'd';
    if (this._placeKey === key) return;
    this._placeKey = key;
    if (mobile) {
      const active = this.cards[this.index];
      this.row.insertBefore(active, this.thumbRow);
      this.cards.forEach(c => { if (c !== active) this.thumbRow.appendChild(c); });
    } else {
      this.cards.forEach(c => this.row.insertBefore(c, this.thumbRow));
    }
  }
}

if (!customElements.get('drv-ingredients')) {
  customElements.define('drv-ingredients', DrvIngredients);
}
